import { NgModule } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { BrowserModule } from '@angular/platform-browser'
import { LocationStrategy, HashLocationStrategy } from '@angular/common'
import { DataTablesModule } from 'angular-datatables'
import { AppComponent } from './app.component'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { TabsModule } from 'ngx-bootstrap/tabs'
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive'
import { PdfViewerModule } from 'ng2-pdf-viewer'
import { OverlayModule } from '@angular/cdk/overlay'
import { ToastrModule } from 'ngx-toastr'
import { CommonModule } from '@angular/common'
import { NgSelectModule } from '@ng-select/ng-select'

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatToolbarModule,
  MatTooltipModule
} from '@angular/material'

import { ChartsModule } from 'ng2-charts/ng2-charts'
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive'
import { AsideToggleDirective } from './shared/aside.directive'
import { BreadcrumbsComponent } from './shared/breadcrumb.component'

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
// Routing Module
import { AppRoutingModule } from './app.routing'

import { AuthInterceptor } from './shared/AuthInterceptor'

// Layouts
import { FullLayoutComponent } from './layouts/full-layout.component'
// Service
import { ApiClientService } from '../app/service/api-client.service'
import { AuthService } from '../app/service/auth.service'
import { CpmService } from '../app/service/cpm.service'
import { HttpModule } from '@angular/http'
import { ExportExcelService } from '../app/service/export-excel.service'
import { ExportPPTService } from '../app/service/export-ppt.service'
//
import { AmChartsModule } from '@amcharts/amcharts3-angular'
import { MarketLevelSummaryComponent } from './market-level/market-level-summary/market-level-summary.component'
import { MarketPerformanceComponent } from './market-level/market-performance/market-performance.component'
import { CapitalRaisedIpoSoComponent } from './market-level/capital-raised-ipo-so/capital-raised-ipo-so.component'
import { CapitalRaisedInstrumentsComponent } from './market-level/capital-raised-instruments/capital-raised-instruments.component'
import { MarketLevelComponent } from './market-level/market-level/market-level.component'
import { MarketLevelHistoricalDataComponent } from './market-level/market-level-historical-data/market-level-historical-data.component'
// tslint:disable-next-line:max-line-length
import { MarketLevelGlobalIndexMemberComponent } from './market-level/market-level-global-index-member/market-level-global-index-member.component'
import { MarketLevelWatchListComponent } from './market-level/market-level-watch-list/market-level-watch-list.component'
import { HistoricalIndicesComponent } from './market-level/historical-indices/historical-indices.component'
import { DatePipe } from '@angular/common'
import { ExistingListedSecuritiesComponent } from './market-level/existing-listed-securities/existing-listed-securities.component'
import { WatchListComponent } from './market-level/watch-list/watch-list.component'
import { GlobalIndexMemberComponent } from './market-level/global-index-member/global-index-member.component'
import { CompareExchangesComponent } from './market-level/compare-exchanges/compare-exchanges.component'
import { MarcroDataEconComponent } from './market-level/marcro-data-econ/marcro-data-econ.component'
import { InitialPublicOfferingComponent } from './market-level/initial-public-offering/initial-public-offering.component'
import { MarketCapRankComponent } from './market-level/market-cap-rank/market-cap-rank.component'
import { ProfitComponent } from './market-level/profit/profit.component'
import { MarketCapRankPeComponent } from './market-level/market-cap-rank-pe/market-cap-rank-pe.component'
import { MarketCapRankTopSecurityComponent } from './market-level/market-cap-rank-top-security/market-cap-rank-top-security.component'
import { AseanExchangesComponent } from './market-level/asean-exchanges/asean-exchanges.component'
import { IpoExchangeIn5YearComponent } from './market-level/ipo-exchange-in-5-year/ipo-exchange-in-5-year.component'
import { MarcroDataComponent } from './market-level/marcro-data/marcro-data.component'
import { ProfitDataComponent } from './market-level/profit-data/profit-data.component'
import { IndustryLevelComponent } from './industry-level/industry-level/industry-level.component'
import { SectorProfitComponent } from './industry-level/sector-profit/sector-profit.component'
import { SectorProfitDataComponent } from './industry-level/sector-profit-data/sector-profit-data.component'
import { SectorPopupComponent } from './industry-level/sector-popup/sector-popup.component'
import { SectorPopupDataComponent } from './industry-level/sector-popup-data/sector-popup-data.component'
import { SecuritiesLevelComponent } from './securities-level/securities-level/securities-level.component'
import { SearchBoxComponent } from './securities-level/search-box/search-box.component'
import { AddressExecutiveSummaryComponent } from './securities-level/address-executive-summary/address-executive-summary.component'
// tslint:disable-next-line:max-line-length
import { BusinessDescriptionExecutiveSummaryComponent } from './securities-level/business-description-executive-summary/business-description-executive-summary.component'
// tslint:disable-next-line:max-line-length
import { AdditionalExecutiveSummaryComponent } from './securities-level/additional-executive-summary/additional-executive-summary.component'
import { ExecutiveSummaryComponent } from './securities-level/executive-summary/executive-summary.component'
import { CompanyHeaderComponent } from './securities-level/company-header/company-header.component'
import { IpoExecutiveSummaryComponent } from './securities-level/ipo-executive-summary/ipo-executive-summary.component'
import { AnalyzeExecutiveSummaryComponent } from './securities-level/analyze-executive-summary/analyze-executive-summary.component'
import { RevenueExecutiveSummaryComponent } from './securities-level/revenue-executive-summary/revenue-executive-summary.component'
// tslint:disable-next-line:max-line-length
import { CompanyStructureExecutiveSummaryComponent } from './securities-level/company-structure-executive-summary/company-structure-executive-summary.component'
import { ShareholderInfoComponent } from './securities-level/shareholder/shareholder-info/shareholder-info.component'
import { ShareholderGoogleComponent } from './securities-level/shareholder/shareholder-google/shareholder-google.component'
import { HttpServiceService } from './service/http-service.service'
import { SafeHtmlPipe } from './pipe/safe-html.pipe'
import { PricePipe } from './pipe/price.pipe'
import { FinancialPipe } from './pipe/financial.pipe'
import { FinancialIntPipe } from './pipe/finaicial-int.pipe'
import { ModalModule, TypeaheadModule, ModalOptions } from 'ngx-bootstrap'
import { BoardShareholderComponent } from './securities-level/board-shareholder/board-shareholder.component'
import { BoardStructureComponent } from './securities-level/board-structure/board-structure.component'
import { MajorShareholderComponent } from './securities-level/major-shareholder/major-shareholder.component'
import { BodScreenComponent } from './securities-level/bod/bod-screen/bod-screen.component'
import { BodInfoComponent } from './securities-level/bod/bod-info/bod-info.component'
// tslint:disable-next-line:max-line-length
import { UploadFileComponent } from './securities-level/upload-file/upload-file.component'
import { PdfService } from './service/pdf.service'
import { StoreService } from './service/store.service'
import { FreeFloatComponent } from './securities-level/free-float/free-float.component'
// tslint:disable-next-line:max-line-length
import { ForeignLimitComponent } from 'app/securities-level/foreign-limit/foreign-limit.component'
import { NavbarComponent } from './layouts/navbar/navbar.component'
import { SidebarComponent } from './layouts/sidebar/sidebar.component'
import { TradingCompareToPeerComponent } from './securities-level/trading-compare-to-peer/trading-compare-to-peer.component'
import { TradingComponent } from './securities-level/trading/trading.component'
import { TradingHeaderComponent } from './securities-level/trading-header/trading-header.component'
import { TradingStatisticComponent } from './securities-level/trading-statistic/trading-statistic.component'
import { AdditionalInfoComponent } from './securities-level/additional-info/additional-info.component'
import { AdditionalInfoCustomerComponent } from './securities-level/additional-info-customer/additional-info-customer.component'
import { AdditionalInfoCompetitorComponent } from './securities-level/additional-info-competitor/additional-info-competitor.component'
import { AdditionalInfoOtherComponent } from './securities-level/additional-info-other/additional-info-other.component'
import { PricePerformanceComponent } from './securities-level/price-performance/price-performance.component'
// tslint:disable-next-line:max-line-length
import { TradingCashBalanceAndAlertComponent } from './securities-level/trading-cash-balance-and-alert/trading-cash-balance-and-alert.component'
import { TradingAverageComponent } from './securities-level/trading-average/trading-average.component'
// tslint:disable-next-line:max-line-length
import { TradingCompareToPeerPopupComponent } from './securities-level/trading-compare-to-peer-popup/trading-compare-to-peer-popup.component'
import { InputComponent } from './crm/input/input.component'
import { CrmScreenComponent } from './crm/crm-screen/crm-screen.component'
import { CaseTableComponent } from './crm/case-table/case-table.component'
import { CrmCaseComponent } from './crm/crm-case/crm-case.component'
import { ExportButtonComponent } from './common-component/export-button/export-button.component'
// tslint:disable-next-line:max-line-length
import { AdditionalInfoForeignExposureComponent } from './securities-level/additional-info-foreign-exposure/additional-info-foreign-exposure.component'
import { OutputComponent } from './crm/output/output.component'
import { OutputCaseTableComponent } from './crm/output-case-table/output-case-table.component'
import { OutputCaseComponent } from './crm/output-case/output-case.component'
import { CrmEditCaseComponent } from './crm/crm-edit-case/crm-edit-case.component'
import { ContactFormComponent } from './crm/contact-form/contact-form.component'
import { ContactComponent } from './crm/contact/contact.component'
import { ContactTableComponent } from './crm/contact-table/contact-table.component'
import { StaffContactComponent } from './crm/staff-contact/staff-contact.component'
import { AeSummaryComponent } from './crm/ae-summary/ae-summary.component'
import { AeSummaryCaseTableComponent } from './crm/ae-summary-case-table/ae-summary-case-table.component'
import { AeSummaryVisitSummaryByTeamComponent } from './crm/ae-summary-visit-summary-by-team/ae-summary-visit-summary-by-team.component'
import { AeSummaryCaseStockComponent } from './crm/ae-summary-case-stock/ae-summary-case-stock.component'
// tslint:disable-next-line:max-line-length
import { AeSummaryVisitSummaryByIndividualComponent } from 'app/crm/ae-summary-visit-summary-by-individual/ae-summary-visit-summary-by-individual.component'
import { CrmContinueActionComponent } from 'app/crm/crm-continue-action/crm-continue-action.component'
// tslint:disable-next-line:max-line-length
import { FinancialComponent } from './securities-level/financial/financial.component'
import { FinancialHeaderComponent } from './securities-level/financial-header/financial-header.component'
import { FinancialTableComponent } from './securities-level/financial-table/financial-table.component'
import { LoginComponent } from './login/login.component'
import { CorporateScreenComponent } from './securities-level/corporate-action/corporate-screen/corporate-screen.component'
import { SummaryComponent } from './securities-level/corporate-action/summary/summary.component'
import { TransactionComponent } from './securities-level/corporate-action/transaction/transaction.component'
import { DividendPaymentComponent } from './securities-level/corporate-action/dividend-payment/dividend-payment.component'
import { OtherActionComponent } from './securities-level/corporate-action/other-action/other-action.component'
import { ParChangeComponent } from './securities-level/corporate-action/par-change/par-change.component'
import { CheckSymbolComponent } from './common-component/check-symbol/check-symbol.component'
// tslint:disable-next-line:max-line-length
import { RevenueContributionScreenComponent } from './securities-level/revenue-contribution/revenue-contribution-screen/revenue-contribution-screen.component'
// tslint:disable-next-line:max-line-length
import { RevenueContributionDataComponent } from './securities-level/revenue-contribution/revenue-contribution-data/revenue-contribution-data.component'
import { SetAttendeesComponent } from './crm/set-attendees/set-attendees.component'
import { CompanyAttendeesComponent } from './crm/company-attendees/company-attendees.component'
import { StatusComponent } from './crm/status/status.component'
import { ContinueCaseSelectBoxComponent } from './crm/continue-case-select-box/continue-case-select-box.component'
import { RevenueTableComponent } from './securities-level/revenue-table/revenue-table.component'
import { CompanyStructureTableComponent } from './securities-level/company-structure-table/company-structure-table.component'
import { CompanyStructurePictureComponent } from './securities-level/company-structure-picture/company-structure-picture.component'
import { FullFactSheetScreenComponent } from './securities-level/full-fact-sheet/full-fact-sheet-screen/full-fact-sheet-screen.component'
// tslint:disable-next-line:max-line-length
import { FullFactSheetPage1ScreenComponent } from './securities-level/full-fact-sheet/full-fact-sheet-page-1/full-fact-sheet-page-1-screen/full-fact-sheet-page-1-screen.component'
// tslint:disable-next-line:max-line-length
import { CompanyAeComponent } from './admin/company-ae/company-ae.component'
import { AdminComponent } from './admin/admin/admin.component'
import { CompanyAeTableComponent } from './admin/company-ae-table/company-ae-table.component'
import { CompanyAeFormAddComponent } from './admin/company-ae-form-add/company-ae-form-add.component'
import { AuthorizeService } from 'app/service/authorize.service'
import { PermissionDeniedComponent } from './common-component/permission-denied/permission-denied.component'
import { CompanyAeSymbolComponent } from './admin/company-ae-symbol/company-ae-symbol.component'
import { CrmScreenInputComponent } from './crm/crm-screen-input/crm-screen-input.component'
// tslint:disable-next-line:max-line-length
import { FullFactSheetBusinessDescriptionComponent } from './securities-level/full-fact-sheet/full-fact-sheet-page-1/full-fact-sheet-business-description/full-fact-sheet-business-description.component'
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client'
import { ZeroNumberPipe } from './pipe/zero-number.pipe'

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    AmChartsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    DataTablesModule,
    PdfViewerModule,
    OverlayModule,
    CommonModule,
    NgSelectModule,
    ModalModule.forRoot(),
    TypeaheadModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-center'
    }),
    LoadingBarHttpClientModule
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    MarketLevelComponent,
    MarketPerformanceComponent,
    CapitalRaisedIpoSoComponent,
    CapitalRaisedInstrumentsComponent,
    MarketLevelHistoricalDataComponent,
    MarketLevelGlobalIndexMemberComponent,
    MarketLevelWatchListComponent,
    MarketLevelSummaryComponent,
    HistoricalIndicesComponent,
    ExistingListedSecuritiesComponent,
    WatchListComponent,
    GlobalIndexMemberComponent,
    CompareExchangesComponent,
    MarcroDataEconComponent,
    InitialPublicOfferingComponent,
    MarketCapRankComponent,
    ProfitComponent,
    MarketCapRankPeComponent,
    MarketCapRankTopSecurityComponent,
    AseanExchangesComponent,
    IpoExchangeIn5YearComponent,
    MarcroDataComponent,
    ProfitDataComponent,
    IndustryLevelComponent,
    SectorProfitComponent,
    SectorProfitDataComponent,
    SectorPopupComponent,
    SectorPopupDataComponent,
    SecuritiesLevelComponent,
    SearchBoxComponent,
    AddressExecutiveSummaryComponent,
    BusinessDescriptionExecutiveSummaryComponent,
    AdditionalExecutiveSummaryComponent,
    ExecutiveSummaryComponent,
    CompanyHeaderComponent,
    IpoExecutiveSummaryComponent,
    AnalyzeExecutiveSummaryComponent,
    RevenueExecutiveSummaryComponent,
    CompanyStructureExecutiveSummaryComponent,
    ShareholderInfoComponent,
    ShareholderGoogleComponent,
    SafeHtmlPipe,
    PricePipe,
    FinancialPipe,
    FinancialIntPipe,
    BoardShareholderComponent,
    BoardStructureComponent,
    MajorShareholderComponent,
    BodScreenComponent,
    BodInfoComponent,
    UploadFileComponent,
    FreeFloatComponent,
    ForeignLimitComponent,
    NavbarComponent,
    SidebarComponent,
    TradingCompareToPeerComponent,
    TradingComponent,
    TradingHeaderComponent,
    TradingStatisticComponent,
    AdditionalInfoComponent,
    AdditionalInfoCustomerComponent,
    AdditionalInfoCompetitorComponent,
    AdditionalInfoOtherComponent,
    PricePerformanceComponent,
    TradingCashBalanceAndAlertComponent,
    TradingAverageComponent,
    TradingCompareToPeerPopupComponent,
    InputComponent,
    CrmScreenComponent,
    CaseTableComponent,
    CrmCaseComponent,
    ExportButtonComponent,
    AdditionalInfoForeignExposureComponent,
    OutputComponent,
    OutputCaseTableComponent,
    OutputCaseComponent,
    CrmEditCaseComponent,
    ContactFormComponent,
    ContactComponent,
    ContactTableComponent,
    StaffContactComponent,
    AeSummaryComponent,
    AeSummaryCaseTableComponent,
    AeSummaryVisitSummaryByTeamComponent,
    AeSummaryVisitSummaryByIndividualComponent,
    AeSummaryCaseStockComponent,
    CrmContinueActionComponent,
    FinancialComponent,
    FinancialHeaderComponent,
    FinancialTableComponent,
    LoginComponent,
    CorporateScreenComponent,
    SummaryComponent,
    TransactionComponent,
    DividendPaymentComponent,
    OtherActionComponent,
    ParChangeComponent,
    CheckSymbolComponent,
    RevenueTableComponent,
    RevenueContributionScreenComponent,
    RevenueContributionDataComponent,
    SetAttendeesComponent,
    CompanyAttendeesComponent,
    StatusComponent,
    ContinueCaseSelectBoxComponent,
    CompanyStructureTableComponent,
    CompanyStructurePictureComponent,
    FullFactSheetPage1ScreenComponent,
    FullFactSheetScreenComponent,
    CompanyAeComponent,
    AdminComponent,
    CompanyAeTableComponent,
    CompanyAeFormAddComponent,
    PermissionDeniedComponent,
    CompanyAeSymbolComponent,
    CrmScreenInputComponent,
    FullFactSheetBusinessDescriptionComponent,
    ZeroNumberPipe
  ],
  providers: [
    ApiClientService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    CpmService,
    HttpServiceService,
    AuthService,
    ExportExcelService,
    ExportPPTService,
    DatePipe,
    PdfService,
    StoreService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    AuthorizeService,
    ModalOptions
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/app.module.ts